import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';

function ModuleLogoCarousel(container) {
	this.container = container;

	const autoplay = container.getAttribute('data-autoplay-timeout') ? parseInt(container.getAttribute('data-autoplay-timeout')) : false;
	const transitionDuration = container.getAttribute('data-transition-duration') ? parseInt(container.getAttribute('data-transition-duration')) : 500;

	this.glide = new Glide(this.container, {
		type: 'carousel',
		animationDuration: transitionDuration,
		autoplay: autoplay,
		gap: 120,
		bound: true,
		peek: 40,
		perView: 4,
		breakpoints: {
			400: {
				perView: 1,
				peek: 40
			},
			700: {
				perView: 2,
				peek: 40
			},
			900: {
				perView: 3,
				gap: 80,
				peek: 40
			},
		}
	});

	this.activateSlider();
}

ModuleLogoCarousel.prototype.activateSlider = function() {
	this.glide.mount();
}

export default ModuleLogoCarousel;